import { FaAngleDown } from "react-icons/fa";
import useDropdown from "../../util/hooks/useDropDown";

interface Props {
  onDelete: () => void;
  onView: () => void;
}

export default function TemplateActionDropdown({ onDelete,onView }: Props) {
  const { isOpen, toggleDropdown, dropdownRef, closeDropdown } = useDropdown();

  const handleActionClick = (action: string) => {
    if (action === "Delete") onDelete();
    if (action === "View") onView();

    closeDropdown();
  };

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      <button
        onClick={toggleDropdown}
        className="flex gap-2 bg-primary-50 text-primary-700 font-medium px-3 py-2 items-center rounded"
      >
        Action
        <FaAngleDown
          className={`transition-transform duration-200 ${
            isOpen ? "rotate-180" : "rotate-0"
          }`}
        />
      </button>

      {isOpen && (
        <div className="absolute z-[9999] mt-1 w-44 bg-white border rounded-lg shadow-lg">
          {["View", "Edit", "Delete", "De-activate", "Duplicate"].map(
            (item) => (
              <button
                key={item}
                className={`w-full text-left px-4 py-2 text-sm hover:bg-primary-50
                  ${
                    item === "Delete"
                      ? "text-error-600 font-medium"
                      : "text-neutral-600"
                  }`}
                onClick={() => handleActionClick(item)}
              >
                {item}
              </button>
            ),
          )}
        </div>
      )}
    </div>
  );
}
